import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

/**
 * @congress/platform-helpers v1.1.11
 * @version 1.1.11
 * @author Vincent Le Quec
 * @copyright Vincent Le Quec 2021-2022
 * @license CYIM: www.cyim.com
 */
var Configuration = /*#__PURE__*/function () {
  function Configuration() {
    _classCallCheck(this, Configuration);
  }

  _createClass(Configuration, null, [{
    key: "EnvConfig",
    get: function get() {
      return {
        VUE_APP_GRAPHQL_HTTP: "$VUE_APP_GRAPHQL_HTTP",
        VUE_APP_GRAPHQL_WS: "$VUE_APP_GRAPHQL_WS",
        VUE_APP_PROM_HTTP: "$VUE_APP_PROM_HTTP",
        VUE_APP_GTM_TAG: "$VUE_APP_GTM_TAG",
        VUE_APP_JITSI_HTTP: "$VUE_APP_JITSI_HTTP",
        VUE_APP_GATEWAY_API: "$VUE_APP_GATEWAY_API",
        VUE_APP_KEYCLOACK_URL: "$VUE_APP_KEYCLOACK_URL",
        VUE_APP_FIREBASE_OPTIONS: "$VUE_APP_FIREBASE_OPTIONS",
        VUE_APP_KUZZLE_URL: "$VUE_APP_KUZZLE_URL",
        VUE_APP_KUZZLE_PORT: "$VUE_APP_KUZZLE_PORT"
      };
    }
  }, {
    key: "value",
    value: function value(key) {
      // If the key does not exist in the EnvConfig object of the class, return null
      if (!Object.prototype.hasOwnProperty.call(this.EnvConfig, key)) {
        console.error("Configuration: There is no key named \"".concat(key, "\". Please add it in Configuration class."));
        return;
      } // Get the value


      var value = this.EnvConfig[key]; // If the value is null, return

      if (!value) {
        console.error("Configuration: Value for \"".concat(key, "\" is not defined"));
        return;
      }

      if (!value.startsWith("$VUE_APP_")) {
        // value was already replaced, it seems we are in production (containerized).
        return value;
      } // value was not replaced, it seems we are in development.


      var envName = value.substr(1); // Remove $ and get current value from process.env

      var envValue = process.env[envName];

      if (!envValue) {
        console.error("Configuration: Environment variable \"".concat(envName, "\" is not defined"));
        return;
      }

      return envValue;
    }
  }]);

  return Configuration;
}();

export { Configuration as default };
//# sourceMappingURL=config.js.map
